import React, { useLayoutEffect, useRef, useState } from 'react';
import { joinFixedEventDisplayLine } from '../../utils/dashboardWeeklyCalendar';

type Props = {
  names: readonly string[];
};

const DashboardCalendarFixedEventMarquee: React.FC<Props> = ({ names }) => {
  const viewportRef = useRef<HTMLDivElement | null>(null);
  const firstRef = useRef<HTMLSpanElement | null>(null);
  const [loop, setLoop] = useState(false);
  const line = joinFixedEventDisplayLine(names);

  useLayoutEffect(() => {
    const vp = viewportRef.current;
    const first = firstRef.current;
    if (!vp || !first || !line) {
      setLoop(false);
      return;
    }
    const check = () => {
      setLoop(first.scrollWidth > vp.clientWidth + 1);
    };
    check();
    const ro = new ResizeObserver(check);
    ro.observe(vp);
    ro.observe(first);
    return () => ro.disconnect();
  }, [line]);

  if (!line) return null;

  const segment = `${line} · `;
  const durationSec = Math.max(8, Math.min(40, line.length * 0.42));
  return (
    <div
      ref={viewportRef}
      className={'cp-dash-weekly-cal-event-marquee' + (loop ? ' is-loop' : '')}
      title={line}
      aria-label={line}
      style={loop ? ({ ['--cp-dash-cal-event-marquee-dur' as string]: `${durationSec}s` } as React.CSSProperties) : undefined}
    >
      <div className="cp-dash-weekly-cal-event-marquee-track">
        <span ref={firstRef} className="cp-dash-weekly-cal-event-marquee-seg">
          {loop ? segment : line}
        </span>
        {loop ? (
          <span className="cp-dash-weekly-cal-event-marquee-seg" aria-hidden>
            {segment}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default DashboardCalendarFixedEventMarquee;
